import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, unref as _unref, createBlock as _createBlock, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  class: "text-preview",
  "aria-label": "文本对话编辑器"
}
const _hoisted_2 = { class: "text-preview-toolbar" }
const _hoisted_3 = { class: "text-preview-summary" }
const _hoisted_4 = {
  class: "text-preview-zoom",
  role: "group",
  "aria-label": "文本预览缩放"
}
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "text-preview-legend" }
const _hoisted_8 = { class: "text-editing-workspace" }
const _hoisted_9 = {
  key: 0,
  class: "text-preview-empty"
}
const _hoisted_10 = {
  key: 1,
  class: "text-canvas-panel"
}
const _hoisted_11 = ["width", "height"]
const _hoisted_12 = ["data-text-edge"]
const _hoisted_13 = ["d", "marker-end"]
const _hoisted_14 = ["data-text-block", "aria-label", "aria-current", "onClickCapture", "onFocusin"]
const _hoisted_15 = { class: "text-block-header" }
const _hoisted_16 = { class: "text-block-kind" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = {
  key: 1,
  class: "detached-badge"
}
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["aria-label", "onClick"]
const _hoisted_22 = {
  key: 0,
  class: "text-block-title"
}
const _hoisted_23 = {
  key: 1,
  class: "text-block-lines"
}
const _hoisted_24 = ["data-dialogue-id", "data-dialogue-clip-id", "onPointerdown"]
const _hoisted_25 = {
  key: 2,
  class: "text-node-summary"
}
const _hoisted_26 = {
  key: 3,
  class: "text-block-outlets"
}
const _hoisted_27 = { class: "text-outlet-number" }
const _hoisted_28 = { class: "option-heading" }
const _hoisted_29 = ["aria-pressed", "onClick"]
const _hoisted_30 = ["onClick"]
const _hoisted_31 = ["aria-label", "onClick"]
const _hoisted_32 = {
  key: 4,
  class: "text-flow-end"
}
const _hoisted_33 = {
  key: 5,
  class: "text-block-ports",
  role: "group",
  "aria-label": "选择后续出口"
}
const _hoisted_34 = ["aria-pressed", "aria-label", "title", "onClick"]
const _hoisted_35 = {
  class: "port-marker",
  "aria-hidden": "true"
}
const _hoisted_36 = {
  class: "text-collection-panel",
  "aria-label": "集合操作"
}
const _hoisted_37 = { class: "panel-field collection-navigator" }
const _hoisted_38 = ["value"]
const _hoisted_39 = {
  key: 0,
  class: "panel-field"
}
const _hoisted_40 = { class: "panel-section" }
const _hoisted_41 = ["disabled"]
const _hoisted_42 = ["title", "disabled", "onClick"]
const _hoisted_43 = {
  key: 0,
  class: "panel-hint",
  role: "alert"
}
const _hoisted_44 = {
  key: 1,
  class: "panel-hint"
}
const _hoisted_45 = { class: "panel-section" }
const _hoisted_46 = ["disabled"]
const _hoisted_47 = ["disabled"]
const _hoisted_48 = {
  key: 0,
  class: "panel-hint"
}
const _hoisted_49 = {
  key: 1,
  class: "panel-section"
}
const _hoisted_50 = {
  key: 2,
  class: "panel-section"
}
const _hoisted_51 = { class: "panel-field" }
const _hoisted_52 = {
  key: 3,
  class: "panel-section"
}
const _hoisted_53 = {
  key: 1,
  class: "panel-hint"
}

import StudioSelectField from "../StudioSelectField.vue";
import { computed, nextTick, onBeforeUnmount, onMounted, ref, watch } from "vue";
import type { DialogueProject } from "./types/FileStruct";
import { buildDialogueTextPreview, isDialogueCollectionNode, type TextPreviewBlock, type TextPreviewLine } from "./utils/dialogueTextPreview";
import { layoutDialogueTextPreview } from "./utils/dialogueTextPreviewLayout";
import { shouldShowDialogueSpeaker, type DialogueTextEdit } from "./utils/dialogueTextEditing";
import { applyDialogueTextAction, type DialogueTextAction } from "./utils/dialogueTextActions";
import { canUndoDialogueDeletion, captureDialogueDeletion } from "./utils/dialogueDeletionUndo";
import DialogueTextLine from "./components/DialogueTextLine.vue";
import DialogueSpeakerPicker from "./components/DialogueSpeakerPicker.vue";
import StudioSelect from "../StudioSelect.vue";
import DialogueMinimap from "./components/DialogueMinimap.vue";
import type { MinimapRect } from "./utils/dialogueMinimap";
import DialogueOptionText from "./components/DialogueOptionText.vue";
import VisualConditionEditor from "./components/VisualConditionEditor.vue";
import SelectOptionIcon from "./components/SelectOptionIcon.vue";
import { DEFAULT_SELECT_ICON_ID } from "./config/selectStyleRegistry";
import type { EntityPreset } from "../EntityPresetEditor/entityPresets";
import { getTextPreviewNavigationTarget, type TextPreviewNavigationTarget } from "./utils/dialogueTextNavigation";
import { getDialogueClips } from "./utils/dialogueClips";


export default /*@__PURE__*/_defineComponent({
  __name: 'DialogueTextPreview',
  props: {
    project: {},
    entityPresets: { default: () => [] },
    presetsError: { default: "" },
    managedHistory: { type: Boolean, default: false }
  },
  emits: ["navigate", "edit", "option", "optionIcon", "replace", "retryPresets"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
const preview = computed(() => buildDialogueTextPreview(props.project));
const namedPresets = computed(() => props.entityPresets.filter(preset => preset.talker.trim()));
const speakerPickerNodeId = ref("");
const speakerPickerClipId = ref<string>();
const speakerPickerDialogue = computed(() => {
  const node = props.project.dialogue.nodes[speakerPickerNodeId.value];
  return node ? getDialogueClips(node).find(clip => clip.id === speakerPickerClipId.value) : undefined;
});
function openSpeakerPicker(line: TextPreviewLine) {
  speakerPickerNodeId.value = line.nodeId;
  speakerPickerClipId.value = line.clipId;
}
function selectSpeaker(talker: string, subtitle: string) {
  emit("edit", { nodeId: speakerPickerNodeId.value, clipId: speakerPickerClipId.value, field: "speaker", value: talker });
  emit("edit", { nodeId: speakerPickerNodeId.value, clipId: speakerPickerClipId.value, field: "subtitle", value: subtitle });
}
const speakerAliases = computed(() => {
  const aliases = new Map<string, string>();
  // Presets arrive system-first; use the first nonempty alias for an exact Talker match.
  for (const preset of props.entityPresets) {
    if (preset.talker.trim() && preset.name.trim() && !aliases.has(preset.talker)) {
      aliases.set(preset.talker, preset.name);
    }
  }
  return aliases;
});
const deletedDialogue = ref<ReturnType<typeof captureDialogueDeletion>>();
watch(() => props.project, project => {
  if (deletedDialogue.value && !canUndoDialogueDeletion(deletedDialogue.value, project)) deletedDialogue.value = undefined;
}, { deep: true });
async function undoDeletion() {
  const snapshot = deletedDialogue.value;
  if (!snapshot || !canUndoDialogueDeletion(snapshot, props.project)) return;
  deletedDialogue.value = undefined;
  emit("replace", snapshot.project);
  await nextTick();
  const block = preview.value.blocks.find(item => snapshot.blockId ? item.id === snapshot.blockId : item.nodeIds.includes(snapshot.nodeId));
  if (block) focusBlock(block.id);
}
const blockById = computed(() => new Map(preview.value.blocks.map((block) => [block.id, block])));
const edgeById = computed(() => new Map(preview.value.edges.map((edge) => [edge.id, edge])));
const heights = ref<Record<string, number>>({});
const collectionWidth = ref(560);
const layout = computed(() => layoutDialogueTextPreview(preview.value, heights.value, collectionWidth.value));
const placedBlocks = computed(() => layout.value.blocks.map((placed) => ({
  ...placed, block: blockById.value.get(placed.id)!,
})));
const viewport = ref<HTMLElement>();
const surface = ref<HTMLElement>();
const zoom = ref(1);
const minimapViewport = ref<MinimapRect>({ x: 0, y: 0, width: 0, height: 0 });
let minimapFrame = 0;
function syncMinimapViewport() {
  const view = viewport.value, canvas = surface.value;
  if (!view || !canvas) return;
  const viewRect = view.getBoundingClientRect(), canvasRect = canvas.getBoundingClientRect();
  // DOM bounds account for padding and the centered canvas when zoomed out.
  minimapViewport.value = {
    x: (viewRect.left + view.clientLeft - canvasRect.left) / zoom.value,
    y: (viewRect.top + view.clientTop - canvasRect.top) / zoom.value,
    width: view.clientWidth / zoom.value, height: view.clientHeight / zoom.value,
  };
}
function scheduleMinimapSync() {
  if (disposed || minimapFrame) return;
  minimapFrame = requestAnimationFrame(() => { minimapFrame = 0; syncMinimapViewport(); });
}
function navigateMinimap(position: { x: number; y: number }) {
  const view = viewport.value;
  if (!view) return;
  syncMinimapViewport();
  view.scrollBy({ left: (position.x - minimapViewport.value.x) * zoom.value,
    top: (position.y - minimapViewport.value.y) * zoom.value, behavior: "auto" });
  scheduleMinimapSync();
}
watch([layout, zoom], scheduleMinimapSync, { flush: "post" });
const arrowId = `text-flow-arrow-${crypto.randomUUID()}`;
const returnArrowId = `${arrowId}-return`;
const lineCount = computed(() => preview.value.blocks.reduce(
  (count, block) => count + block.lines.filter((line) => line.hasDialogue).length, 0,
));
const detachedBlocks = computed(() => preview.value.blocks.filter((block) => !block.reachable && block.kind !== 'entry' && block.kind !== 'output'));
const detachedCount = computed(() => detachedBlocks.value.length);
const activeBlockId = ref("");
const activeBlock = computed(() => blockById.value.get(activeBlockId.value));
const chosenOutletId = ref("");
const activeOutletId = computed(() => activeBlock.value?.outlets.find((outlet) => outlet.id === chosenOutletId.value)?.id ?? activeBlock.value?.outlets[0]?.id ?? "");
const outletOptions = computed(() => activeBlock.value?.outlets.map(outlet => ({ id: outlet.id, label: outlet.text || outlet.label })) ?? []);
const currentOutletTarget = computed(() => activeBlock.value
  ? outletTarget(activeBlock.value.id, activeBlock.value.outlets.findIndex(outlet => outlet.id === activeOutletId.value)) : "");
const connectionOptions = computed(() => [
  { id: "", label: "未连接" },
  ...preview.value.blocks.filter(block => block.kind !== "entry" && (block.id !== activeBlock.value?.id || currentOutletTarget.value === block.id))
    .map(target => ({ id: target.id, label: `${blockLabel(target)} · ${target.lines[0]?.content?.slice(0, 20) || target.title}` })),
]);
function selectBlock(id: string) {
  if (activeBlockId.value !== id) chosenOutletId.value = "";
  activeBlockId.value = id;
}
function selectOutlet(blockId: string, outletId: string) {
  if (!blockById.value.get(blockId)?.outlets.some(outlet => outlet.id === outletId)) return;
  selectBlock(blockId);
  chosenOutletId.value = outletId;
}
function append(kind: "dialogue" | "select" | "condition", preset?: EntityPreset) {
  if (!activeBlock.value || !activeOutletId.value) return;
  act({ type: "append", blockId: activeBlock.value.id, outletId: activeOutletId.value, kind, preset });
}
const draggingLine = ref("");
const dropLine = ref("");
const dragPreview = ref<{ line: TextPreviewLine; index: number; repeatSpeaker: boolean; left: number; top: number; width: number; scale: number }>();
const dragCard = ref<HTMLElement>();
let dropAnimation: Animation | undefined;
let dragRevision = 0;
let lineDrag: { pointerId: number; x: number; y: number; offsetX: number; offsetY: number; moved: boolean; element: HTMLElement } | undefined;
const panning = ref(false);
let pan: { pointerId: number; x: number; y: number; left: number; top: number } | undefined;
function startPan(event: PointerEvent) {
  if (lineDrag) return;
  const target = event.target as HTMLElement;
  if (event.button !== 1 && (event.button !== 0 || target.closest("article, button, input, textarea, select"))) return;
  if (!viewport.value) return;
  event.preventDefault();
  pan = { pointerId: event.pointerId, x: event.clientX, y: event.clientY, left: viewport.value.scrollLeft, top: viewport.value.scrollTop };
  viewport.value.setPointerCapture(event.pointerId);
  panning.value = true;
}
function movePan(event: PointerEvent) {
  if (!pan || !viewport.value) return;
  viewport.value.scrollLeft = pan.left + pan.x - event.clientX;
  viewport.value.scrollTop = pan.top + pan.y - event.clientY;
}
function endPan() { pan = undefined; panning.value = false; }
function focusBlock(id: string) {
  const placed = layout.value.blocks.find((item) => item.id === id);
  if (!placed || !viewport.value) return;
  selectBlock(id);
  const element = surface.value?.querySelector<HTMLElement>(`[data-text-block="${CSS.escape(id)}"]`);
  if (element) viewport.value.scrollBy({
    left: element.getBoundingClientRect().left - viewport.value.getBoundingClientRect().left - (viewport.value.clientWidth - placed.width * zoom.value) / 2,
    top: element.getBoundingClientRect().top - viewport.value.getBoundingClientRect().top - 32,
    behavior: "smooth",
  });
}
async function act(action: DialogueTextAction) {
  // Preserve the edited sentence's screen position across block regrouping.
  const id = "nodeId" in action ? action.nodeId : undefined;
  const clipSelector = "clipId" in action && action.clipId ? `[data-dialogue-clip-id="${CSS.escape(action.clipId)}"]` : "";
  const oldElement = id ? surface.value?.querySelector<HTMLElement>(`[data-dialogue-id="${CSS.escape(id)}"]${clipSelector}`) : undefined;
  const oldRect = oldElement?.getBoundingClientRect();
  const result = applyDialogueTextAction(props.project, action);
  if (!result) return;
  const deleting = action.type === "delete" || action.type === "delete-outlet" || action.type === "delete-block";
  deletedDialogue.value = deleting && !props.managedHistory ? captureDialogueDeletion(props.project, result.project, id ?? "", "blockId" in action ? action.blockId : undefined) : undefined;
  emit("replace", result.project);
  await nextTick();
  measureBlocks();
  await nextTick();
  // Reordering should keep the viewport where the user dropped the sentence.
  // Do not compensate its position, scroll it into view, or open its inputs.
  if (action.type === "move") {
    const block = preview.value.blocks.find(item => item.nodeIds.includes(action.nodeId));
    if (block) selectBlock(block.id);
    return;
  }
  if (result.focusBlockId && blockById.value.has(result.focusBlockId)) {
    focusBlock(result.focusBlockId);
  } else if (result.nodeId) {
    const block = preview.value.blocks.find((item) => item.nodeIds.includes(result.nodeId!));
    if (block) selectBlock(block.id);
    const element = surface.value?.querySelector<HTMLElement>(`[data-dialogue-id="${CSS.escape(result.nodeId)}"]`);
    if (oldRect && element && viewport.value) {
      const rect = element.getBoundingClientRect();
      viewport.value.scrollLeft += rect.left - oldRect.left;
      viewport.value.scrollTop += rect.top - oldRect.top;
    }
    element?.querySelector<HTMLTextAreaElement>("textarea")?.focus({ preventScroll: true });
    element?.scrollIntoView({ block: "nearest", inline: "nearest" });
    if (block && !element?.querySelector("textarea")) focusBlock(block.id);
  } else if (deleting && !blockById.value.has(activeBlockId.value)) {
    const block = preview.value.blocks.find(item => item.kind === "entry") ?? preview.value.blocks[0];
    if (block) focusBlock(block.id);
  }
}
function movable(id: string) {
  const node = props.project.dialogue.nodes[id];
  return !!node && getDialogueClips(node).length === 1 && isDialogueCollectionNode(node) && node.dialogue?.advanceMode === "PlayerInput";
}
function canInsertLine(id: string) {
  const node = props.project.dialogue.nodes[id];
  return !!node && getDialogueClips(node).length <= 1;
}
function canMove(block: TextPreviewBlock, index: number, delta: number) {
  return !!block.lines[index + delta] && movable(block.lines[index].nodeId) && movable(block.lines[index + delta].nodeId);
}
function moveLine(block: TextPreviewBlock, index: number, delta: number) {
  if (canMove(block, index, delta)) act({ type: "move", nodeId: block.lines[index].nodeId, targetId: block.lines[index + delta].nodeId });
}
function insertLine(id: string) { if (canInsertLine(id)) act({ type: "insert", nodeId: id, before: !movable(id) }); }
function startLineDrag(event: PointerEvent, id: string) {
  if (event.button !== 0 || !(event.target as HTMLElement).closest(".line-grip")) return;
  const block = preview.value.blocks.find(item => item.lines.some(line => line.nodeId === id));
  if (!block || !movable(id) || block.lines.length < 2) return;
  event.preventDefault();
  event.stopPropagation();
  endLineDrag();
  dragRevision++;
  dropAnimation?.cancel();
  dropAnimation = undefined;
  draggingLine.value = id;
  const element = event.currentTarget as HTMLElement;
  const rect = element.getBoundingClientRect();
  const index = block.lines.findIndex(line => line.nodeId === id);
  dragPreview.value = {
    line: block.lines[index], index,
    repeatSpeaker: !shouldShowDialogueSpeaker(block.lines, index) && !element.matches(":focus-within"),
    left: rect.left, top: rect.top, width: rect.width / zoom.value, scale: zoom.value,
  };
  element.setPointerCapture(event.pointerId);
  lineDrag = { pointerId: event.pointerId, x: event.clientX, y: event.clientY,
    offsetX: event.clientX - rect.left, offsetY: event.clientY - rect.top, moved: false, element };
}
function canDrop(block: TextPreviewBlock, id: string) {
  return id !== draggingLine.value && movable(id) && block.lines.some((line) => line.nodeId === draggingLine.value);
}
function dragLine(event: PointerEvent) {
  if (!lineDrag || event.pointerId !== lineDrag.pointerId || !dragPreview.value) return;
  dragPreview.value.left = event.clientX - lineDrag.offsetX;
  dragPreview.value.top = event.clientY - lineDrag.offsetY;
  if (!lineDrag.moved && Math.hypot(event.clientX - lineDrag.x, event.clientY - lineDrag.y) < 4) return;
  lineDrag.moved = true;
  const element = document.elementFromPoint(event.clientX, event.clientY)?.closest<HTMLElement>("[data-dialogue-id]");
  const id = element?.dataset.dialogueId;
  const block = preview.value.blocks.find((item) => item.lines.some((line) => line.nodeId === id));
  dropLine.value = id && block && canDrop(block, id) ? id : "";
  const bounds = viewport.value?.getBoundingClientRect();
  if (bounds && event.clientY > bounds.top && event.clientY < bounds.bottom) {
    if (event.clientY < bounds.top + 36) viewport.value?.scrollBy(0, -16);
    else if (event.clientY > bounds.bottom - 36) viewport.value?.scrollBy(0, 16);
  }
}
async function endLineDrag(commit = false) {
  if (!lineDrag) return;
  const revision = ++dragRevision;
  const nodeId = draggingLine.value;
  const from = dragCard.value?.getBoundingClientRect();
  const action: DialogueTextAction | undefined = commit && lineDrag.moved && dropLine.value
    ? { type: "move", nodeId: draggingLine.value, targetId: dropLine.value } : undefined;
  const { element, pointerId } = lineDrag;
  lineDrag = undefined;
  dragPreview.value = undefined;
  draggingLine.value = ""; dropLine.value = "";
  if (element.hasPointerCapture(pointerId)) element.releasePointerCapture(pointerId);
  if (action) await act(action);
  else await nextTick();
  if (disposed || revision !== dragRevision || !from || window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
  const target = surface.value?.querySelector<HTMLElement>(`[data-dialogue-id="${CSS.escape(nodeId)}"]`);
  if (!target) return;
  const to = target.getBoundingClientRect();
  if (!to.width || !to.height) return;
  // Animate from the floating card's screen position to the final layout,
  // accounting for canvas zoom without moving the viewport.
  const animation = target.animate([
    { transform: `translate(${(from.left - to.left) / zoom.value}px, ${(from.top - to.top) / zoom.value}px) scale(${from.width / to.width}, ${from.height / to.height})`,
      transformOrigin: "top left", background: "#fff", boxShadow: "0 16px 34px #263d6430, 0 4px 10px #263d641a", zIndex: 3 },
    { transform: "translate(0, 0) scale(1)", transformOrigin: "top left", background: "#fff", boxShadow: "0 0 0 transparent", zIndex: 3 },
  ], { duration: 220, easing: "cubic-bezier(0.22, 1, 0.36, 1)" });
  dropAnimation = animation;
  animation.onfinish = () => { if (dropAnimation === animation) dropAnimation = undefined; };
}
function cancelLineDrag() { endLineDrag(); }
function handleDragKey(event: KeyboardEvent) {
  if (lineDrag && event.key === "Escape") { event.preventDefault(); endLineDrag(); }
}
function outletTarget(blockId: string, index: number) {
  return preview.value.edges.find((edge) => edge.source === blockId && edge.outletIndex === index)?.target ?? "";
}
function tailId(block: TextPreviewBlock) { return block.nodeIds[block.nodeIds.length - 1]; }
function editOption(block: TextPreviewBlock, outletId: string, value: string) {
  emit("option", tailId(block), outletId.slice("select:".length), value);
}
const kindLabels = {
  entry: "开始", dialogue: "对话集合", select: "选项卡", action: "演出节点", condition: "条件分支", output: "结束",
};
function blockLabel(block: TextPreviewBlock) {
  return block.kind === "select" && block.lines.some((line) => line.hasDialogue) ? "对话 + 选项" : kindLabels[block.kind];
}

function navigateToBlock(block: TextPreviewBlock, lineNodeId?: string, outlet = false) {
  const target = getTextPreviewNavigationTarget(block, lineNodeId, outlet);
  if (target) emit("navigate", target);
}

function changeZoom(value: number) {
  const previous = zoom.value;
  const view = viewport.value;
  const centerX = view ? (view.scrollLeft + view.clientWidth / 2) / previous : 0;
  const centerY = view ? (view.scrollTop + view.clientHeight / 2) / previous : 0;
  zoom.value = Math.max(0.4, Math.min(1.5, Math.round(value * 100) / 100));
  nextTick(() => { if (view) { view.scrollLeft = centerX * zoom.value - view.clientWidth / 2; view.scrollTop = centerY * zoom.value - view.clientHeight / 2; } });
}
function fitWidth() {
  if (viewport.value) changeZoom((viewport.value.clientWidth - 48) / layout.value.width);
}
function edgeDescription(id: string) {
  const edge = edgeById.value.get(id);
  if (!edge) return "";
  const source = blockById.value.get(edge.source);
  const target = blockById.value.get(edge.target);
  const outlet = source?.outlets[edge.outletIndex];
  return `${source?.title ?? ""} → ${target?.title ?? ""}${outlet?.text ? `：${outlet.text}` : ""}`;
}

let observer: ResizeObserver | undefined;
let disposed = false;
function measureBlocks() {
  scheduleMinimapSync();
  if (viewport.value) collectionWidth.value = Math.max(320, Math.min(560, viewport.value.clientWidth - 64));
  const next: Record<string, number> = {};
  for (const element of surface.value?.querySelectorAll<HTMLElement>("[data-text-block]") ?? []) {
    next[element.dataset.textBlock!] = element.offsetHeight;
  }
  if (Object.keys(next).length !== Object.keys(heights.value).length ||
      Object.entries(next).some(([id, height]) => heights.value[id] !== height)) {
    heights.value = next;
  }
}
async function observeBlocks() {
  await nextTick();
  if (disposed) return;
  observer?.disconnect();
  if (viewport.value) observer?.observe(viewport.value);
  for (const element of surface.value?.querySelectorAll("[data-text-block]") ?? []) observer?.observe(element);
  measureBlocks();
}
onMounted(async () => {
  window.addEventListener("keydown", handleDragKey);
  window.addEventListener("blur", cancelLineDrag);
  selectBlock(preview.value.blocks.find((block) => block.reachable && block.lines.length)?.id ?? preview.value.blocks[0]?.id ?? "");
  observer = new ResizeObserver(measureBlocks);
  await observeBlocks();
  await nextTick();
  measureBlocks();
  await nextTick();
  if (!disposed) focusBlock(activeBlockId.value);
});
watch(collectionWidth, async () => {
  await nextTick();
  measureBlocks();
});
watch(preview, (value, previous) => {
  if (!value.blocks.some((block) => block.id === activeBlockId.value)) {
    const previousIds = previous.blocks.find((block) => block.id === activeBlockId.value)?.nodeIds ?? [];
    activeBlockId.value = value.blocks.find((block) => block.nodeIds.some((id) => previousIds.includes(id)))?.id ?? value.blocks[0]?.id ?? "";
  }
  observeBlocks();
});
onBeforeUnmount(() => {
  disposed = true;
  if (minimapFrame) cancelAnimationFrame(minimapFrame);
  dropAnimation?.cancel();
  endLineDrag();
  window.removeEventListener("keydown", handleDragKey);
  window.removeEventListener("blur", cancelLineDrag);
  observer?.disconnect();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[23] || (_cache[23] = _createElementVNode("strong", null, "对话手稿", -1)),
        _createElementVNode("span", null, _toDisplayString(lineCount.value) + " 句台词 · " + _toDisplayString(preview.value.blocks.filter(block => block.kind === 'dialogue').length) + " 个对话集合", 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        (deletedDialogue.value)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              title: "继续编辑前，可恢复刚删除的内容、Clip 和连线",
              onClick: undoDeletion
            }, "撤销删除"))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          type: "button",
          class: "new-group-button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (act({ type: 'create' })))
        }, "＋ 新建集合"),
        _createElementVNode("button", {
          type: "button",
          "aria-label": "缩小文本预览",
          disabled: zoom.value <= 0.4,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (changeZoom(zoom.value - 0.1)))
        }, "−", 8, _hoisted_5),
        _createElementVNode("button", {
          type: "button",
          title: "重置为 100%",
          "aria-label": "重置文本预览缩放",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (changeZoom(1)))
        }, _toDisplayString(Math.round(zoom.value * 100)) + "%", 1),
        _createElementVNode("button", {
          type: "button",
          "aria-label": "放大文本预览",
          disabled: zoom.value >= 1.5,
          onClick: _cache[3] || (_cache[3] = ($event: any) => (changeZoom(zoom.value + 0.1)))
        }, "＋", 8, _hoisted_6),
        _createElementVNode("button", {
          type: "button",
          onClick: fitWidth
        }, "适合宽度")
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _cache[24] || (_cache[24] = _createElementVNode("span", null, "点击选择集合 · 右侧添加内容 · 拖动空白处平移 · Ctrl+Enter 续写", -1)),
      _cache[25] || (_cache[25] = _createElementVNode("span", { class: "return-legend" }, "虚线：返回前文", -1)),
      (detachedCount.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "detached-legend",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (focusBlock(detachedBlocks.value[(detachedBlocks.value.findIndex(block => block.id === activeBlockId.value) + 1) % detachedCount.value].id)))
          }, _toDisplayString(detachedCount.value) + " 组散落文本 · 点击查看", 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_8, [
      (!preview.value.blocks.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _cache[26] || (_cache[26] = _createElementVNode("p", null, "从第一句对话开始。", -1)),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (act({ type: 'create' })))
            }, "＋ 写下第一句")
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", {
              ref_key: "viewport",
              ref: viewport,
              class: _normalizeClass(["text-preview-viewport", { 'is-panning': panning.value, 'is-dragging-line': draggingLine.value }]),
              tabindex: "0",
              "aria-label": "文本流程画布",
              onScrollPassive: scheduleMinimapSync,
              onPointerdown: startPan,
              onPointermove: movePan,
              onPointerup: endPan,
              onPointercancel: endPan,
              onLostpointercapture: endPan
            }, [
              _createElementVNode("div", {
                class: "text-preview-size",
                style: _normalizeStyle({ width: `${layout.value.width * zoom.value}px`, height: `${layout.value.height * zoom.value}px` })
              }, [
                _createElementVNode("div", {
                  ref_key: "surface",
                  ref: surface,
                  class: "text-preview-surface",
                  style: _normalizeStyle({ width: `${layout.value.width}px`, height: `${layout.value.height}px`, transform: `scale(${zoom.value})` })
                }, [
                  (_openBlock(), _createElementBlock("svg", {
                    class: "text-preview-connections",
                    width: layout.value.width,
                    height: layout.value.height,
                    "aria-label": "文本框之间的流程连线"
                  }, [
                    _createElementVNode("defs", null, [
                      _createElementVNode("marker", {
                        id: arrowId,
                        viewBox: "0 0 10 10",
                        refX: "9",
                        refY: "5",
                        markerWidth: "7",
                        markerHeight: "7",
                        orient: "auto-start-reverse"
                      }, [...(_cache[27] || (_cache[27] = [
                        _createElementVNode("path", {
                          d: "M 0 0 L 10 5 L 0 10 z",
                          fill: "#8195ac"
                        }, null, -1)
                      ]))]),
                      _createElementVNode("marker", {
                        id: returnArrowId,
                        viewBox: "0 0 10 10",
                        refX: "9",
                        refY: "5",
                        markerWidth: "7",
                        markerHeight: "7",
                        orient: "auto-start-reverse"
                      }, [...(_cache[28] || (_cache[28] = [
                        _createElementVNode("path", {
                          d: "M 0 0 L 10 5 L 0 10 z",
                          fill: "#9871c4"
                        }, null, -1)
                      ]))])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(layout.value.edges, (edge) => {
                      return (_openBlock(), _createElementBlock("g", {
                        key: edge.id,
                        "data-text-edge": edge.id,
                        class: _normalizeClass({ 'return-edge': edge.isReturn })
                      }, [
                        _createElementVNode("title", null, _toDisplayString(edge.isReturn ? '返回前文：' : '') + _toDisplayString(edgeDescription(edge.id)), 1),
                        _createElementVNode("path", {
                          d: edge.path,
                          class: "text-flow-edge",
                          "marker-end": `url(#${edge.isReturn ? returnArrowId : arrowId})`
                        }, null, 8, _hoisted_13)
                      ], 10, _hoisted_12))
                    }), 128))
                  ], 8, _hoisted_11)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(placedBlocks.value, (placed) => {
                    return (_openBlock(), _createElementBlock("article", {
                      key: placed.id,
                      "data-text-block": placed.id,
                      class: _normalizeClass(["text-flow-block", [`block-${placed.block.kind}`, { 'block-detached': !placed.block.reachable, 'block-active': activeBlockId.value === placed.id }]]),
                      style: _normalizeStyle({ left: `${placed.x}px`, top: `${placed.y}px`, width: `${placed.width}px` }),
                      "aria-label": placed.block.title,
                      tabindex: "0",
                      "aria-current": activeBlockId.value === placed.id ? 'true' : undefined,
                      onClickCapture: ($event: any) => (selectBlock(placed.id)),
                      onFocusin: ($event: any) => (selectBlock(placed.id))
                    }, [
                      _createElementVNode("header", _hoisted_15, [
                        _createElementVNode("span", _hoisted_16, _toDisplayString(blockLabel(placed.block)), 1),
                        (placed.block.kind === 'dialogue')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(placed.block.lines.length) + " 句对话", 1))
                          : _createCommentVNode("", true),
                        (!placed.block.reachable)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_18, "散落文本"))
                          : _createCommentVNode("", true),
                        _createElementVNode("button", {
                          type: "button",
                          title: "聚焦此组",
                          onClick: ($event: any) => (focusBlock(placed.id))
                        }, "◎", 8, _hoisted_19),
                        _createElementVNode("button", {
                          type: "button",
                          title: "在节点图配置详细 Clip",
                          onClick: ($event: any) => (navigateToBlock(placed.block))
                        }, "节点 ↗", 8, _hoisted_20),
                        (placed.block.kind !== 'entry')
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 2,
                              type: "button",
                              class: "delete-content",
                              "aria-label": `删除${blockLabel(placed.block)}`,
                              title: "删除整个集合或节点，可立即撤销",
                              onClick: ($event: any) => (act({ type: 'delete-block', blockId: placed.block.id }))
                            }, "删除", 8, _hoisted_21))
                          : _createCommentVNode("", true)
                      ]),
                      (['entry', 'output', 'condition'].includes(placed.block.kind))
                        ? (_openBlock(), _createElementBlock("h3", _hoisted_22, _toDisplayString(placed.block.title), 1))
                        : _createCommentVNode("", true),
                      (placed.block.lines.some(line => line.hasDialogue))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(placed.block.lines, (line, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: `${line.nodeId}:${line.clipId ?? ''}`,
                                "data-dialogue-id": line.nodeId,
                                "data-dialogue-clip-id": line.clipId,
                                class: _normalizeClass(["text-line-slot", { 'line-drag-source': draggingLine.value === line.nodeId, 'line-drop-target': dropLine.value === line.nodeId,
                  'line-drop-after': dropLine.value === line.nodeId && index > placed.block.lines.findIndex(item => item.nodeId === draggingLine.value) }]),
                                onPointerdown: ($event: any) => (startLineDrag($event, line.nodeId)),
                                onPointermove: dragLine,
                                onPointerup: _cache[7] || (_cache[7] = ($event: any) => (endLineDrag(true))),
                                onPointercancel: _cache[8] || (_cache[8] = ($event: any) => (endLineDrag())),
                                onLostpointercapture: _cache[9] || (_cache[9] = ($event: any) => (endLineDrag()))
                              }, [
                                (line.hasDialogue)
                                  ? (_openBlock(), _createBlock(DialogueTextLine, {
                                      key: 0,
                                      line: line,
                                      "speaker-alias": speakerAliases.value.get(line.speaker),
                                      index: index,
                                      movable: movable(line.nodeId) && placed.block.lines.length > 1,
                                      "repeat-speaker": !_unref(shouldShowDialogueSpeaker)(placed.block.lines, index),
                                      "can-insert": canInsertLine(line.nodeId),
                                      "can-move-up": canMove(placed.block, index, -1),
                                      "can-move-down": canMove(placed.block, index, 1),
                                      onEdit: _cache[6] || (_cache[6] = ($event: any) => (emit('edit', $event))),
                                      onMove: ($event: any) => (moveLine(placed.block, index, $event)),
                                      onInsert: ($event: any) => (insertLine(line.nodeId)),
                                      onRemove: ($event: any) => (act({ type: 'delete', nodeId: line.nodeId, clipId: line.clipId })),
                                      onPickSpeaker: ($event: any) => (openSpeakerPicker(line)),
                                      onConfigure: ($event: any) => (navigateToBlock(placed.block, line.nodeId)),
                                      onAddDialogue: ($event: any) => (act({ type: 'add-dialogue', nodeId: line.nodeId }))
                                    }, null, 8, ["line", "speaker-alias", "index", "movable", "repeat-speaker", "can-insert", "can-move-up", "can-move-down", "onMove", "onInsert", "onRemove", "onPickSpeaker", "onConfigure", "onAddDialogue"]))
                                  : _createCommentVNode("", true)
                              ], 42, _hoisted_24))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      (placed.block.kind === 'action')
                        ? (_openBlock(), _createElementBlock("p", _hoisted_25, _toDisplayString(placed.block.title) + " · 详细演出在节点图配置", 1))
                        : _createCommentVNode("", true),
                      (placed.block.kind === 'select' || placed.block.kind === 'condition')
                        ? (_openBlock(), _createElementBlock("ol", _hoisted_26, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(placed.block.outlets, (outlet, index) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: outlet.id
                              }, [
                                _createElementVNode("span", _hoisted_27, _toDisplayString(index + 1), 1),
                                _createElementVNode("div", null, [
                                  _createElementVNode("div", _hoisted_28, [
                                    _createElementVNode("small", null, _toDisplayString(outlet.label), 1),
                                    (outlet.kind === 'select')
                                      ? (_openBlock(), _createBlock(SelectOptionIcon, {
                                          key: 0,
                                          "model-value": outlet.icon ?? _unref(DEFAULT_SELECT_ICON_ID),
                                          label: `选项 ${index + 1} 图标`,
                                          "onUpdate:modelValue": ($event: any) => (emit('optionIcon', tailId(placed.block), outlet.id.slice('select:'.length), $event))
                                        }, null, 8, ["model-value", "label", "onUpdate:modelValue"]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  (outlet.kind === 'select')
                                    ? (_openBlock(), _createBlock(DialogueOptionText, {
                                        key: 0,
                                        "model-value": outlet.text,
                                        "onUpdate:modelValue": ($event: any) => (editOption(placed.block, outlet.id, $event))
                                      }, null, 8, ["model-value", "onUpdate:modelValue"]))
                                    : (outlet.kind === 'condition')
                                      ? (_openBlock(), _createBlock(VisualConditionEditor, {
                                          key: 1,
                                          "model-value": outlet.text,
                                          label: outlet.label,
                                          "onUpdate:modelValue": ($event: any) => (act({ type: 'edit-condition', nodeId: tailId(placed.block), outletId: outlet.id, condition: $event }))
                                        }, null, 8, ["model-value", "label", "onUpdate:modelValue"]))
                                      : _createCommentVNode("", true),
                                  _createElementVNode("button", {
                                    class: "outlet-focus",
                                    type: "button",
                                    "aria-pressed": activeBlockId.value === placed.id && activeOutletId.value === outlet.id,
                                    onClick: _withModifiers(($event: any) => (selectOutlet(placed.id, outlet.id)), ["stop"])
                                  }, _toDisplayString(outlet.connected ? '已连接' : '未连接') + " · 从此出口添加", 9, _hoisted_29)
                                ]),
                                (outlet.connected)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      type: "button",
                                      title: "前往此分支",
                                      onClick: ($event: any) => (focusBlock(outletTarget(placed.id, index)))
                                    }, "↗", 8, _hoisted_30))
                                  : _createCommentVNode("", true),
                                (outlet.kind === 'select' || outlet.kind === 'condition')
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 1,
                                      type: "button",
                                      class: "delete-content",
                                      "aria-label": outlet.kind === 'select' ? `删除选项 ${index + 1}` : `删除条件分支项 ${index + 1}`,
                                      title: "删除此项及其连线，保留下游内容",
                                      onClick: ($event: any) => (act({ type: 'delete-outlet', blockId: placed.block.id, outletId: outlet.id }))
                                    }, "×", 8, _hoisted_31))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(placed.block.warnings, (warning, index) => {
                        return (_openBlock(), _createElementBlock("p", {
                          key: index,
                          class: "text-flow-warning"
                        }, _toDisplayString(warning), 1))
                      }), 128)),
                      (placed.block.outlets.length === 1 && !placed.block.outlets[0].connected && ['next', 'entry'].includes(placed.block.outlets[0].kind))
                        ? (_openBlock(), _createElementBlock("p", _hoisted_32, "下一步未连接"))
                        : _createCommentVNode("", true),
                      (placed.block.outlets.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(placed.block.outlets, (outlet, index) => {
                              return (_openBlock(), _createElementBlock("button", {
                                key: outlet.id,
                                type: "button",
                                class: _normalizeClass(["text-block-port", { 'port-unconnected': !outlet.connected, 'port-selected': activeBlockId.value === placed.id && activeOutletId.value === outlet.id, 'port-single': placed.block.outlets.length === 1 }]),
                                "aria-pressed": activeBlockId.value === placed.id && activeOutletId.value === outlet.id,
                                "aria-label": `选择${blockLabel(placed.block)}的出口 ${index + 1}：${outlet.text || outlet.label}`,
                                title: `出口 ${index + 1}：${outlet.text || outlet.label} · 点击设置后续连接`,
                                style: _normalizeStyle({ left: `${(index + 1) / (placed.block.outlets.length + 1) * 100}%` }),
                                onPointerdown: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["stop"])),
                                onClick: _withModifiers(($event: any) => (selectOutlet(placed.id, outlet.id)), ["stop"])
                              }, [
                                _createElementVNode("span", _hoisted_35, _toDisplayString(placed.block.outlets.length > 1 ? index + 1 : ''), 1)
                              ], 46, _hoisted_34))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ], 46, _hoisted_14))
                  }), 128))
                ], 4)
              ], 4)
            ], 34),
            _createVNode(DialogueMinimap, {
              layout: layout.value,
              blocks: preview.value.blocks,
              viewport: minimapViewport.value,
              "active-block-id": activeBlockId.value,
              zoom: zoom.value,
              onNavigate: navigateMinimap
            }, null, 8, ["layout", "blocks", "viewport", "active-block-id", "zoom"])
          ])),
      _createElementVNode("aside", _hoisted_36, [
        _createElementVNode("label", _hoisted_37, [
          _cache[30] || (_cache[30] = _createTextVNode("定位集合或节点 ", -1)),
          _createVNode(StudioSelectField, {
            "aria-label": "聚焦集合或节点",
            value: activeBlockId.value,
            onChange: _cache[11] || (_cache[11] = ($event: any) => (focusBlock(($event.target as HTMLSelectElement).value)))
          }, {
            default: _withCtx(() => [
              _cache[29] || (_cache[29] = _createElementVNode("option", {
                value: "",
                disabled: ""
              }, "聚焦集合或节点…", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(preview.value.blocks, (block, index) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: block.id,
                  value: block.id
                }, _toDisplayString(index + 1) + " · " + _toDisplayString(block.title) + _toDisplayString(!block.reachable ? ' · 散落' : ''), 9, _hoisted_38))
              }), 128))
            ]),
            _: 1
          }, 8, ["value"])
        ]),
        (activeBlock.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("header", null, [
                _cache[31] || (_cache[31] = _createElementVNode("span", { class: "panel-eyebrow" }, "当前选中", -1)),
                _createElementVNode("h3", null, _toDisplayString(blockLabel(activeBlock.value)), 1),
                _createElementVNode("p", null, _toDisplayString(activeBlock.value.kind === 'dialogue' ? `${activeBlock.value.lines.length} 句对话` : activeBlock.value.title), 1)
              ]),
              (activeBlock.value.outlets.length > 1)
                ? (_openBlock(), _createElementBlock("label", _hoisted_39, [
                    _cache[32] || (_cache[32] = _createTextVNode("添加到哪个出口 ", -1)),
                    _createVNode(StudioSelect, {
                      label: "添加到哪个出口",
                      "model-value": activeOutletId.value,
                      options: outletOptions.value,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (chosenOutletId.value = $event))
                    }, null, 8, ["model-value", "options"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_40, [
                _cache[34] || (_cache[34] = _createElementVNode("span", { class: "panel-eyebrow" }, "添加对话", -1)),
                _createElementVNode("button", {
                  type: "button",
                  class: "panel-add-button",
                  disabled: !activeOutletId.value,
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (append('dialogue')))
                }, [
                  _cache[33] || (_cache[33] = _createElementVNode("strong", null, "＋ 默认对话", -1)),
                  _createElementVNode("small", null, _toDisplayString(activeBlock.value.kind === 'dialogue' ? '追加到当前集合末尾' : '在所选出口后创建对话集合'), 1)
                ], 8, _hoisted_41),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(namedPresets.value, (preset) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: preset.id,
                    type: "button",
                    class: "panel-add-button",
                    title: `Talker：${preset.talker}`,
                    disabled: !activeOutletId.value,
                    onClick: ($event: any) => (append('dialogue', preset))
                  }, [
                    _createElementVNode("strong", null, "＋ " + _toDisplayString(preset.name.trim() || preset.talker), 1),
                    _createElementVNode("small", null, _toDisplayString(preset.subtitle || '无副标题') + " · 空白对话", 1)
                  ], 8, _hoisted_42))
                }), 128)),
                (__props.presetsError)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_43, [
                      _createTextVNode(_toDisplayString(__props.presetsError) + " ", 1),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[14] || (_cache[14] = ($event: any) => (emit('retryPresets')))
                      }, "重试")
                    ]))
                  : (!namedPresets.value.length)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_44, "在「编辑内容 → 预设设置 → 预设实体」保存人物，即可从这里添加。"))
                    : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_45, [
                _cache[37] || (_cache[37] = _createElementVNode("span", { class: "panel-eyebrow" }, "创建后续节点", -1)),
                _createElementVNode("button", {
                  type: "button",
                  class: "panel-add-button",
                  disabled: !activeOutletId.value,
                  onClick: _cache[15] || (_cache[15] = ($event: any) => (append('select')))
                }, [...(_cache[35] || (_cache[35] = [
                  _createElementVNode("strong", null, "⑂ 添加选项卡", -1),
                  _createElementVNode("small", null, "在集合下方创建独立选项节点", -1)
                ]))], 8, _hoisted_46),
                _createElementVNode("button", {
                  type: "button",
                  class: "panel-add-button",
                  disabled: !activeOutletId.value,
                  onClick: _cache[16] || (_cache[16] = ($event: any) => (append('condition')))
                }, [...(_cache[36] || (_cache[36] = [
                  _createElementVNode("strong", null, "◇ 添加条件分支", -1),
                  _createElementVNode("small", null, "创建独立条件节点", -1)
                ]))], 8, _hoisted_47),
                (!activeOutletId.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_48, "此节点没有可用出口，请在节点图配置。"))
                  : _createCommentVNode("", true)
              ]),
              (activeBlock.value.kind === 'select')
                ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                    _cache[38] || (_cache[38] = _createElementVNode("span", { class: "panel-eyebrow" }, "当前选项卡", -1)),
                    _createElementVNode("button", {
                      type: "button",
                      class: "panel-secondary",
                      onClick: _cache[17] || (_cache[17] = ($event: any) => (act({ type: 'add-option', nodeId: tailId(activeBlock.value) })))
                    }, "＋ 增加一个选项")
                  ]))
                : _createCommentVNode("", true),
              (activeOutletId.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                    _createElementVNode("label", _hoisted_51, [
                      _cache[39] || (_cache[39] = _createTextVNode("后续连接 ", -1)),
                      _createVNode(StudioSelect, {
                        label: "连接到集合或节点",
                        "model-value": currentOutletTarget.value,
                        options: connectionOptions.value,
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (act({ type: 'connect', blockId: activeBlock.value.id, outletId: activeOutletId.value, targetId: $event })))
                      }, null, 8, ["model-value", "options"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                type: "button",
                class: "panel-secondary",
                onClick: _cache[19] || (_cache[19] = ($event: any) => (navigateToBlock(activeBlock.value)))
              }, "在节点图配置 Clip ↗"),
              (activeBlock.value.kind !== 'entry')
                ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "panel-secondary delete-content",
                      onClick: _cache[20] || (_cache[20] = ($event: any) => (act({ type: 'delete-block', blockId: activeBlock.value.id })))
                    }, "删除" + _toDisplayString(blockLabel(activeBlock.value)), 1)
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          : (_openBlock(), _createElementBlock("div", _hoisted_53, "选择画布中的集合或节点，再在这里添加内容。"))
      ])
    ]),
    (speakerPickerNodeId.value)
      ? (_openBlock(), _createBlock(DialogueSpeakerPicker, {
          key: 0,
          presets: __props.entityPresets,
          speaker: speakerPickerDialogue.value?.speaker ?? '',
          error: __props.presetsError,
          onSelect: selectSpeaker,
          onClose: _cache[21] || (_cache[21] = ($event: any) => (speakerPickerNodeId.value = '')),
          onRetry: _cache[22] || (_cache[22] = ($event: any) => (emit('retryPresets')))
        }, null, 8, ["presets", "speaker", "error"]))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (dragPreview.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "line-drag-preview dsfg-typography",
            "aria-hidden": "true",
            inert: "",
            style: _normalizeStyle({ width: `${dragPreview.value.width}px`, transform: `translate3d(${dragPreview.value.left}px, ${dragPreview.value.top}px, 0) scale(${dragPreview.value.scale})` })
          }, [
            _createElementVNode("div", {
              ref_key: "dragCard",
              ref: dragCard,
              class: "line-drag-card"
            }, [
              _createVNode(DialogueTextLine, {
                line: dragPreview.value.line,
                "speaker-alias": speakerAliases.value.get(dragPreview.value.line.speaker),
                index: dragPreview.value.index,
                "repeat-speaker": dragPreview.value.repeatSpeaker,
                movable: true,
                "can-move-up": false,
                "can-move-down": false
              }, null, 8, ["line", "speaker-alias", "index", "repeat-speaker"])
            ], 512)
          ], 4))
        : _createCommentVNode("", true)
    ]))
  ]))
}
}

})